<template>
    <div class="__page">
        <div class="grid grid-27-23 grid-spaceless grid-die-laptop">
            <div class="element-relative">
                <HomepageBody>
                    <Typo>
                        <div class="typo-custom-lead">
                            <span class="badge badge--secondary float-left fs-77 text-bold">#1</span>
                            <div class="fs-59 text-upper text-bold lead-first text-no-wrap">Dowiedz się</div>
                            <div class="fs-47 text-upper text-bold lead-second text-no-wrap">jako pierwszy</div>
                            <div class="fs-25 lead-third">o najlepszych promocjach i indywidualnych rabatach</div>
                        </div>
                    </Typo>
                    <Typo>
                        <div class="typo-custom-coupon">
                            <p>
                                <img
                                    src="/uploads/images/banner-online.png"
                                    alt=""
                                >
                            </p>
                        </div>
                    </Typo>
                    <Typo
                        :html="bodyHtml"
                        theme="wrapped"
                    />
                    <!-- <Typo>
                        <div class="typo-custom-coupon flex">
                            <p class="coupon-text">
                                <strong>
                                    Sam zdecyduj, która forma kontaktu<br>
                                    będzie dla Ciebie najlepsza i zgarnij<br>
                                    20% rabatu na środki do prania!
                                </strong>
                            </p>
                            <p class="float-right">
                                <img
                                    src="/uploads/images/rabat.jpg"
                                    alt=""
                                >
                            </p>
                        </div>
                    </Typo> -->
                </HomepageBody>
            </div>
            <div class="element-relative homepage-image-container">
                <ImageLazy
                    :height="870"
                    :is-background="true"
                    :image-url="imageUrl"
                    class="homepage-image-lazy"
                    alt=""
                />
                <HomepageForm text="Po zalogowaniu masz również możliwość zarządzania swoimi zgodami">
                    <Panelbox
                        header-text="Zaloguj się i zrezygnuj z gazetki papierowej.<br>
                        <span style='font-size: 1.7rem; line-height: 2rem; margin-top: 9px; display: block'>Zapisz się na newsletter, przeglądaj gazetkę online.</span>"
                        theme="secondary"
                    >
                        <FormboxSignin />
                    </Panelbox>
                </HomepageForm>
            </div>
        </div>

        <Modal
            :is-closeable="true"
            closeLabel="Zamknij okno"
            ref="modal"
        />
    </div>
</template>

<script>
import FormboxSignin from '@/components/formbox/FormboxSignin'
import HomepageBody from '@/components/homepage/HomepageBody'
import HomepageForm from '@/components/homepage/HomepageForm'
import Modal from '@/components/modal/Modal'
import Panelbox from '@/components/panelbox/Panelbox'

export default {
    components: {
        FormboxSignin,
        HomepageBody,
        HomepageForm,
        Modal,
        Panelbox
    },

    computed: {
        campaignData() {
            return this.$store.getters['apiCampaign/campaign']
        },

        bodyHtml() {
            return `
                <div class="typo-box">
                    ${this.campaignData.benefits1 || ''}
                </div>
            `
        },

        imageUrl() {
            return this.campaignData.imageStep1 || ''
        }
    },

    mounted() {
        this.$store.dispatch('steps/intendEntry')

        if (this.$route.meta.info === 'wycofaj') {
            this.$refs.modal
                .open(`<header class="fs-32">Twoja zgoda została zgłoszona do wycofania.</header>`, 'center-small', function() {

                })
        }
    }
}
</script>

<style lang="scss">
.homepage-image-container {
    @media (max-width: $screen-laptop) {
        padding: 0 0 97px;
    }

    @media (max-width: $screen-mobile-landscape) {
        padding: 0;
    }
}

.homepage-image-lazy {
    .image-lazy-background {
        background-position: top;
    }
    
    @media (max-width: $screen-page) and (min-width: $screen-laptop + 1px) {
        // display: none;
    }

    @media (max-width: $screen-laptop) {
        max-width: 75%;
        margin-left: 25%;

        > * {
            height: 473px !important;
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        display: none;
    }
}

.homepage-form {
    @media (min-width: $screen-laptop + 1px) {
        .panelbox {
            width: 57%;
            max-width: 420px;
            min-width: 340px;

            .input {
                &-number,
                &-number-multiple,
                &-text-multiple {
                    input {
                        padding: 10px 5px;
                    }
                }
            }
        }
    }

    @media (max-width: $screen-page) and (min-width: $screen-laptop + 1px) {
        // &-footer {
        //     left: calc(50% - 215px);
        //     padding-right: 20px;
        //     top: 600px;

        //     .text-color-contrast {
        //         color: $color-default;
        //     }
        // }

        // .panelbox {
        //     margin: 0 auto;
        //     display: block;
        // }
    }
}
</style>
